module.exports = __webpack_public_path__ + "media/frames/frame_black_vertical-692e8369.jpg";